import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { getItemsId } from "../../redux/actions/actionItem";
import { getDocuments } from "../../redux/actions/actionDocument";
import { format } from "date-fns";
import DatePicker from "react-datepicker";
import Swal from "sweetalert2";

export default function ItemDetail() {
  const dispatch = useDispatch();
  const item = useSelector((state) => state.items.itemsDetail);
  const documents = useSelector((state) => state.documents.allDocuments);
  const { id } = useParams();
  const [startDate] = useState(new Date());
  const [dateIn, setDateIn] = useState({
    desde: new Date(),
    hasta: new Date(),
  });
  const [documentsItems, setDocumentsItems] = useState();

  useEffect(() => {
    dispatch(getDocuments());
    dispatch(getItemsId(id));
  }, [dispatch, id]);

  //console.log(id);
  console.log(documents);
  console.log(documentsItems);
  

  const handleDesde = (date) => {
    console.log(date);
    setDateIn({ ...dateIn, desde: date });
  };

  const handleHasta = (date) => {
    console.log(date);
    if (date > dateIn.desde) {
      console.log(dateIn.desde);
      setDateIn({ ...dateIn, hasta: date });
    } else {
      Swal.fire(`Fecha "Hasta" no puede ser anterior a fecha "Desde"`);
    }
  };

  const handleBuscar = () => {
    let docs = documents[0].filter(
      (e) =>
        new Date(e.dateSend) >= dateIn.desde &&
        new Date(e.dateSend) <= dateIn.hasta
    );
    
    console.log(docs);

    let itemArray = [];
    let itemDocs = docs.map(e => 
        e.quantityItems.filter(x => {
            if(x.item === id){
                itemArray.push(e)
            }
        }))
    console.log(itemDocs);
    
    if (itemArray.length > 0) {
      setDocumentsItems(itemArray);
    } else {
      Swal.fire("El cliente no tiene remitos generados aún");
    }
  };

  const handleLimpiar = () => {
    setDocumentsItems();
  };

  return (
    <div className="min-w-full bg-gray-900">
      <div className="container m-8 text-orange-500 text-[10pt] font-bold">
        <div>
          <p className="my-2">Id Articulo: {item.idItem}</p>
          <p>Nombre: {item.name}</p>
          <p className="my-2">Descripcion: {item.description}</p>
          <p>Stock: {item.stockTotal}</p>
        </div>
        <div className="mt-6 pt-4 border-t-2 border-slate-500">
          <div>Buscar Articulos en Documentos</div>
          <div className="flex mt-4">
            <div className="flex">
              <label>Desde</label>
              <DatePicker
                className="w-24 pl-3 ml-2 rounded bg-slate-700"
                selected={startDate}
                onChange={handleDesde}
                value={dateIn.desde ? format(dateIn.desde, "dd/MM/yyyy") : null}
              />
            </div>
            <div className="flex ml-2">
              <label>Hasta</label>
              <DatePicker
                className="w-24 pl-3 ml-2 rounded bg-slate-700"
                selected={startDate}
                onChange={handleHasta}
                value={dateIn.hasta ? format(dateIn.hasta, "dd/MM/yyyy") : null}
              />
            </div>
            <div className="w-20 ml-2 text-center bg-slate-700 hover:text-white hover:bg-blue-700">
              <button className="" onClick={handleBuscar}>
                Buscar
              </button>
            </div>
            <div className="w-20 ml-2 text-center bg-slate-700 hover:text-white hover:bg-blue-700">
              <button className="" onClick={handleLimpiar}>
                Limpiar
              </button>
            </div>
          </div>
        </div>
        <div className="mt-4">
            <div className="flex">
              <p className="w-12">N° Doc</p>
              <p className="w-20 text-center">Cantidad</p>
              <p className="w-20 text-center">Envío</p>
              <p className="w-20 text-center">Recepción</p>
              <p className="w-20 text-center">Estado</p>
            </div>
            <div className="mt-2">
              {documentsItems &&
                documentsItems.map((e) => {
                  return (
                    <div className="flex" key={e._id}>
                      <Link to={`/documentos/${e._id}`}>
                        <div className="flex">
                          <div className="w-12">{e.numberDocument}</div>
                          <div className="w-20 text-center">{e.quantityItems.map(x => {                            
                              if(x.item === id){
                                return x.quantity
                              }
                            
                          })}</div>
                          <div className="w-20 text-center">
                            {format(new Date(e.dateSend), "dd/MM/yy")}
                          </div>
                          <div className="w-20 text-center">
                            {format(new Date(e.dateReception), "dd/MM/yy")}
                          </div>
                          <div className="w-20 text-center">
                            {e.parcial === true ? (
                              <p className="text-yellow-500">Parcial</p>
                            ) : e.state === true ? (
                              <p className="text-green-500">Saldado</p>
                            ) : (
                              <p className="text-red-600">No Saldado</p>
                            )}
                          </div>
                        </div>
                      </Link>
                    </div>
                  );
                })}
            </div>
          </div>
      </div>
    </div>
  );
}
